export default __webpack_public_path__ + "static/media/fish.b54b8c4a.png";